import Avatar from "@mui/material/Avatar";
import Icon from "@mui/material/Icon";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "store/auth/userSlice";
import { settings } from "settings";

function UserMenu(props) {
	const dispatch = useDispatch();
	const user = useSelector(({ auth }) => auth.user);

	const [userMenu, setUserMenu] = useState(null);

	const userMenuClick = (event) => {
		setUserMenu(event.currentTarget);
	};

	const userMenuClose = () => {
		setUserMenu(null);
	};

	const handleLogout = () => {
		dispatch(logoutUser());
		userMenuClose();
	};

	const handleNavigate = (url) => {
		location.href = url;
		userMenuClose();
	};

	return (
		<>
			<div
				className="min-w-40 px-0 py-0 cursor-pointer flex items-end"
				onClick={userMenuClick}
				color="inherit"
			>
				<div className="mx-4">
					<Typography component="span" className="font-semibold">
						{user.data?.firstName} {user.data?.lastName}
					</Typography>
				</div>

				{user.data?.photoURL ? (
					<Avatar
						className="md:mx-4"
						alt="user photo"
						src={user.data.photoURL}
					/>
				) : (
					<Avatar className="md:mx-4">{user.data?.firstName[0]}</Avatar>
				)}
			</div>

			<Popover
				open={Boolean(userMenu)}
				anchorEl={userMenu}
				onClose={userMenuClose}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "center",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "center",
				}}
				classes={{
					paper: "py-8",
				}}
			>
				<MenuItem
					onClick={() => {
						handleNavigate(settings.urls.myAccount);
					}}
					role="button"
				>
					<ListItemIcon className="min-w-40">
						<Icon className="fa-solid fa-user" />
					</ListItemIcon>
					<ListItemText primary="My Account" />
				</MenuItem>
				<MenuItem
					onClick={() => {
						handleNavigate(settings.urls.orders);
					}}
					role="button"
				>
					<ListItemIcon className="min-w-40">
						<Icon className="fa-solid fa-rectangle-list" />
					</ListItemIcon>
					<ListItemText primary="My Orders" />
				</MenuItem>
				<MenuItem onClick={handleLogout}>
					<ListItemIcon className="min-w-40">
						<Icon className="fa-solid fa-arrow-right-from-bracket" />
					</ListItemIcon>
					<ListItemText primary="Logout" />
				</MenuItem>
			</Popover>
		</>
	);
}

export default UserMenu;
